<!-- BaseDateInput.vue (common) -->
<template tag="공통 날짜 입력 컴포넌트">
  <v-menu
    translate="no"
    transition="slide-y-transition"
    min-width="0"
    scrim
    :close-on-content-click="false"
    v-model="menu"
    :offset="[4, 0]"
  >
    <template v-slot:activator="{ props }">
      <v-text-field
        v-bind="props"
        :id="id"
        density="compact"
        :disabled="disabled"
        :placeholder="placeholder"
        v-model="model"
        :hide-details="true"
        class="search_day form_style"
        :class="[boxSize, $attrs.class]"
        variant="plain"
        clearable
        autocomplete="off"
        @input="handleInput"
      ></v-text-field>
    </template>
    <v-list class="pa-0">
      <v-date-picker
        color="info"
        v-model="selDate"
        @update:model-value="updateDatePicker"
        :show-adjacent-months="true"
      >
        <template v-slot:title></template>
        <template v-slot:header></template>
      </v-date-picker>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import dayjs from "dayjs";

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel({ type: String }); // 부모 컴포넌트랑 주고받는 값

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
defineProps({
  placeholder: { type: String, default: "날짜" },
  disabled: { type: Boolean, default: false },
  id: { type: String, default: "" },
  boxSize: { type: String, default: "" },
});

/* ------------------------------------------------------------
                          Variable Declarations
   ------------------------------------------------------------ */
const menu = ref(false); // 데이트피커(달력) 보이는 것 제어
const selDate = ref(null as unknown); // v-date-picker에서 실제 선택된 값

/* ------------------------------------------------------------
                          Computed Properties
   ------------------------------------------------------------ */
/** selDate(v-date-picker)의 값이 Date 타입으로 넘어오기 때문에 포맷팅해준다. */
const formatted = computed(() => {
  return selDate.value ? dayjs(selDate.value as Date).format("YYYY.MM.DD") : "";
});

/* ------------------------------------------------------------
                          Methods
   ------------------------------------------------------------ */
/** v-date-picker에서 값 선택 시 model에 값을 담아주고 달력을 닫는다 */
const updateDatePicker = () => {
  menu.value = false;
  model.value = formatted.value;
};

/** 입력값 처리 */
const handleInput = () => {
  if (model.value) {
    menu.value = true;
    // 숫자만 추출
    const digits = model.value.replace(/\D/g, "");
    if (digits.length === 8) {
      // YYYY.MM.DD 형식으로 변환
      const formattedDate = `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(6, 8)}`;
      if (dayjs(formattedDate, "YYYY.MM.DD", true).isValid()) {
        selDate.value = dayjs(formattedDate, "YYYY.MM.DD").toDate();
        model.value = formattedDate;
      }
      menu.value = false;
    }
  }
};

/* ------------------------------------------------------------
                          watch
   ------------------------------------------------------------ */
watch(model, () => {
  if (model.value) {
    // 숫자만 추출
    const digits = model.value.replace(/\D/g, "");
    if (digits.length === 8) {
      // YYYY.MM.DD 형식으로 변환
      const formattedDate = `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(6, 8)}`;
      if (dayjs(formattedDate, "YYYY.MM.DD", true).isValid()) {
        selDate.value = dayjs(formattedDate, "YYYY.MM.DD").toDate();
        return;
      }
    }
  } else {
    selDate.value = null;
  }
});
</script>
